import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { CookiesProvider } from "react-cookie";
import { useCookies } from "react-cookie";

import ProviderPage from "../ProviderPage";
import ContractPage from "../ContractPage";
import css from "./App.module.css";
import Nav from "../Nav";
import LandingPage from "../LandingPage";
import Login from "../Login";
import Dash from "../Dash";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import logo from "../Login/WMCA logo.png";

import LoginPage from "../Login/index";
import Register from "../RegiserUser/index";
import { SERVER_URL } from "../../config";

export const routes = {
  provider: "/provider",
  contracts: "/contracts",
  landingPage: "/landingPage",
  dash: "/dash"
};

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  let history = useHistory();
  async function submitLogin(email, password) {
    const res = await fetch(`${SERVER_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      },
      body: JSON.stringify({
        email,
        password
      })
    });
    const data = await res.json();
    if (data.payload === true) {
      setLoggedIn(true);

      // history.push("/provider");
      history.push("/dash");

      // change the loggedIn state here to true;
    } else {
      alert("Incorrect email or password");
    }
    console.log("This is the login user response" + data.payload);
  }

  return (
    <Router>
      <div className={css.app}>
        {loggedIn ? (
          <>
            <Nav />
            <Switch>
              <Route path={routes.dash} component={Dash} />
              <Route path={routes.landingPage} component={LandingPage} />
              <Route path={routes.provider} component={ProviderPage} />
              <Route path={`${routes.contracts}/:id`}>
                <ContractPage />
              </Route>
            </Switch>
          </>
        ) : (
          <div className={css.loginContainer}>
            <Switch>
              <Route path="/RegisterUser" component={Register} />
              <Login submitLogin={submitLogin} />
              {Dash} />
            </Switch>
            <img className={css.Applogo} src={logo} alt="WMCA logo" />
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
